import { render, staticRenderFns } from "./Skins.vue?vue&type=template&id=84f944de&scoped=true&"
import script from "./Skins.vue?vue&type=script&lang=js&"
export * from "./Skins.vue?vue&type=script&lang=js&"
import style0 from "./Skins.vue?vue&type=style&index=0&id=84f944de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f944de",
  null
  
)

export default component.exports